<div #barcodeTarget class="barcode-target" [class.dimmed]="dimVideo"></div> <loading-animation *ngIf="showSpinner" class="spinner"></loading-animation>


// WEBPACK FOOTER //
// ng:///builds/lyonzy/shelvable/web/static/components/barcode-scanner/barcode-scanner.html